<div class="page-header">
  <h1 class="mt-4 d-inline-block">{{user?.displayName}}'s Login Settings</h1>
</div>
<div class="container" [ngClass]="{defaultTab:!linkSelected}">
  <aside class="nav-bar">
    <b class="select-msg">Please select one of the tabs below to view more:</b>
    <app-vertical-nav [links]="links" [activeLink]="activeLink.name" (activeLinkChange)="changeRoute($event)" />
  </aside>
  <section tabindex="0" class="content">
    @if (!isLoading) {
      @if (activeLink.tag === 'contact-info') {
        @if (!showProfileForm) {
          <div>
            <button [ngbTooltip]="'Navigate to Tab List'" aria-label="Navigate to Tab List" class="button-without-border pr-2 return-icon" (click)="navigateToDefaultTab()">
              <span class="fa fa-angle-left"></span>
            </button>
            <b role="heading" aria-level="1" class="nav-content-header">Contact Information</b>
            <div class="grid">
              <div>
                <app-user-profile-card [canUpdateContact]="true" [profile]="profile!" (update)="selectProfile(profile!)" />
              </div>
            </div>
          </div>
        }
        @if (showProfileForm) {
          <div>
            <app-request-to-update-information [profile]="profile!" [reRgId]="profile!.NameId" (cancelRequest)="showProfileForm = false" />
          </div>
        }
      }
      @if (activeLink.tag === 'mfa') {
        <button [ngbTooltip]="'Navigate to Tab List'" aria-label="Navigate to Tab List" class="button-without-border pr-2 return-icon" (click)="navigateToDefaultTab()">
          <span class="fa fa-angle-left"></span>
        </button>
        <b role="heading" aria-level="1" class="nav-content-header">Multifactor Authentication (MFA)</b>
        <p>
          The MFA options are used as an additional method to verify the identity of the person logging into the client portal or mobile app. Please let us know if changes are needed.
        </p>
        <button class="btn btn-sm btn-outline-primary" (click)="openModalToContactAdvisor(content, 'Update')">Request Update</button>
        <div class="mt-4" style="border-top: thin solid lightgrey">
          <div class="mt-4">
            <div class="mr-2 d-inline-block">
              <b>Verification Email (Required)</b>
            </div>
            <div class="pull-right">
              {{profile?.TwoFAEmail}}
            </div>
          </div>
          <div class="pt-4">
            <div class="mr-2 d-inline-block">
              <b>Verification Cell Phone Number (Optional)</b>
            </div>
            <div class="pull-right">
              {{profile?.TwoFAPhone}}
            </div>
          </div>
        </div>
      }
      @if (activeLink.tag === 'change-password') {
        <button [ngbTooltip]="'Navigate to Tab List'" aria-label="Navigate to Tab List" class="button-without-border pr-2 return-icon" (click)="navigateToDefaultTab()">
          <span class="fa fa-angle-left"></span>
        </button>
        <b role="heading" aria-level="1" class="nav-content-header">Change Your Password</b>
        <nwm-profile-reset-password />
      }
      @if (activeLink.tag.indexOf('rg/')===0 && reRg) {
        @if (!showProfileForm) {
          <div>
            @if (user?.isClient && canEditKYC) {
              <button class="btn btn-sm btn-outline-primary" style="float: right; margin-top: -5px;" (click)="auth.openKYC(false, reRg.ReRgId)" [disabled]="config.demoSite" [title]="config.demoSite ? 'This functionality is not available on Demo Web Site' :''">View KYC</button>
            }
            <div>
              <button [ngbTooltip]="'Navigate to Tab List'" aria-label="Navigate to Tab List" class="button-without-border pr-2 return-icon" (click)="navigateToDefaultTab()">
                <span class="fa fa-angle-left"></span>
              </button>
              <b role="heading" aria-level="1" class="nav-content-header mb-4" style="font-size:24px">{{reRg.ClientName}}</b>
              <br>
                <b role="heading" aria-level="1" class="nav-content-header">Related Contacts</b>
                @if (relatedProfiles.length === 0) {
                  <i>
                    No related profile is found.
                  </i>
                }
                <div class="grid">
                  @for (related of relatedProfiles; track related) {
                    <div>
                      <app-user-profile-card [canUpdateContact]="canUpdateContact" [profile]="related" (update)="selectProfile(related)" />
                    </div>
                  }
                </div>
              </div>
              @if (reRg.RergType!=='PGF') {
                <div>
                  <b role="heading" aria-level="1" class="nav-content-header mt-4">Accountants & Lawyers</b>
                  @if (accOrLawyersProfiles.length === 0) {
                    <i class="d-block">
                      There are no accountants and lawyers recorded.
                    </i>
                  }
                  <div class="grid">
                    @for (related of accOrLawyersProfiles; track related) {
                      <div>
                        <app-user-profile-card [profile]="related" [relatedProfiles]="relatedProfiles" (update)="selectProfile(related)" />
                      </div>
                    }
                  </div>
                </div>
              }
              @if (usersWithAccessToCurrentReRg.length > 0) {
                <div>
                  <b role="heading" aria-level="1" class="nav-content-header mt-4">Reporting Group Sharing</b>
                  <p class="mt-2">The people listed here have been granted access to this reporting group. Please let us know if changes are needed.</p>
                  <ul>
                    @for (user of usersWithAccessToCurrentReRg; track user) {
                      <li>
                        {{user.Name}}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
          @if (showProfileForm) {
            <div>
              <app-request-to-update-information [profile]="selectedProfile" [reRgId]="reRg.ReRgId" (cancelRequest)="showProfileForm = false" />
            </div>
          }
        }
        @if (activeLink.name === 'Legal') {
          <button [ngbTooltip]="'Navigate to Tab List'" aria-label="Navigate to Tab List" class="button-without-border pr-2 return-icon" (click)="navigateToDefaultTab()">
            <span class="fa fa-angle-left"></span>
          </button>
          <b role="heading" aria-level="1" class="nav-content-header">Legal</b>
          <div class="mt-3">
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#terms-and-conditions">Terms and Conditions</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#canadian-privacy-policy">Nicola Wealth Canadian Privacy Policy</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#canadian-privacy-policy">Confidentiality Policy for Residents of Quebec under Bill 64</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#us-privacy-policy">Nicola Wealth U.S. Privacy Policy</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/accessibility">Accessibility Policy</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#trade-matching-and-settlement">Trade Matching &amp; Settlement</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#registration-status">Registration Status</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#complaint-handling-policy">Complaint Handling Policy</a></p>
            <p class="mb-2"><a target="_blank" href="https://nicolawealth.com/legal#contact-compliance">Contact Compliance</a></p>
          </div>
          <div class="mt-4">
            <p class="mb-2"><a target="_blank" href="/assets/managed-investment-account-agreement-jan-2026.pdf">Managed Investment Account Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Conflict%20of%20Interest%20Disclosure%20Statement.pdf">Conflict of Interest Disclosure</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/relationship-disclosure-information-statement-december-31-2025.pdf">Relationship Disclosure Information</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Fund%20Disclosure%20Document.pdf">Fund Disclosure Document</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Wealth%20Form%20CRS.pdf">Nicola Wealth Form CRS</a></p>
          </div>
          <div class="mt-4">
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Canadian%20Real%20Estate%20Limited%20Partnership%20Agreement.pdf">Nicola Canadian Real Estate Limited Partnership Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Credit%20Opportunities%20Limited%20Partnership%20Agreement.pdf">Nicola Credit Opportunities Limited Partnership Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Global%20Infrastructure%20Limited%20Partnership%20Agreement.pdf">Nicola Global Infrastructure Limited Partnership Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Private%20Equity%20Limited%20Partnership%20Agreement.pdf">Nicola Private Equity Limited Partnership Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20U.S.%20Real%20Estate%20Limited%20Partnership%20Agreement.pdf">Nicola U.S. Real Estate Limited Partnership Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Value%20Add%20Real%20Estate%20Limited%20Partnership%20Agreement.pdf">Nicola Value Add Real Estate Limited Partnership Agreement</a></p>
            <p class="mb-2"><a target="_blank" href="/assets/Nicola%20Venture%20Capital%20Limited%20Partnership%20Agreement.pdf">Nicola Venture Capital Limited Partnership Agreement</a></p>
          </div>
        }
      }
    </section>
  </div>

  <ng-template #content let-modal>
    <nwm-advisor-contact [isMFARequest]="true" formAction="MessageAdvisor" [formTitle]="contactFormTitle" (formCancelled)="modal.close()" />
  </ng-template>
